import moment from 'moment';
export function timeFix() {
  const time = new Date();
  const hour = time.getHours();
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好';
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了'];
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents');
  event.initEvent('resize', true, true);
  event.eventType = 'message';
  window.dispatchEvent(event);
}

export function handleScrollHeader(callback) {
  let timer = 0;

  let beforeScrollTop = window.pageYOffset;
  callback = callback || function () {};
  window.addEventListener(
    'scroll',
    (event) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        let direction = 'up';
        const afterScrollTop = window.pageYOffset;
        const delta = afterScrollTop - beforeScrollTop;
        if (delta === 0) {
          return false;
        }
        direction = delta > 0 ? 'down' : 'up';
        callback(direction);
        beforeScrollTop = afterScrollTop;
      }, 50);
    },
    false
  );
}

export function isIE() {
  const bw = window.navigator.userAgent;
  const compare = (s) => bw.indexOf(s) >= 0;
  const ie11 = (() => 'ActiveXObject' in window)();
  return compare('MSIE') || ie11;
}

export function formatFileSize(bytes) {
  if (bytes === 0) return '0 B'; // 处理 0 的情况

  // 检测操作系统
  const base = 1024;
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

  // 计算绝对值的单位索引和大小
  const absBytes = Math.abs(bytes); // 取绝对值进行计算
  const i = Math.floor(Math.log(absBytes) / Math.log(base));
  const size = absBytes / Math.pow(base, i);

  // 根据大小决定小数位数
  let decimals = 2;
  if (size >= 100) decimals = 0;
  else if (size >= 10) decimals = 1;

  // 保留负号（如果是负数）
  const formattedSize = `${size.toFixed(decimals)} ${units[i]}`;
  return bytes < 0 ? `-${formattedSize}` : formattedSize;
}
/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return;
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id));
  }, timeout);
}
export function scorePassword(pass) {
  let score = 0;
  if (!pass) {
    return score;
  }
  // award every unique letter until 5 repetitions
  const letters = {};
  for (let i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5.0 / letters[pass[i]];
  }

  // bonus points for mixing it up
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass),
  };

  let variationCount = 0;
  for (var check in variations) {
    variationCount += variations[check] === true ? 1 : 0;
  }
  score += (variationCount - 1) * 10;

  return parseInt(score);
}

export function TimestampToLocalTime(timestamp) {
  // // 转换为 Date 对象
  // const date = new Date(timestamp);

  // // 转为英文地区时间
  // const formattedDate = date.toLocaleString('en-US', {
  //   timeZone: 'UTC', // 可根据需要设置时区
  //   weekday: 'long', // 显示星期
  //   year: 'numeric',
  //   month: 'long',
  //   day: 'numeric',
  //   hour: 'numeric',
  //   minute: 'numeric',
  //   second: 'numeric',
  // });
  // return formattedDate;
  // 转换为 Date 对象
  const date = new Date(timestamp);

  // 获取月份缩写
  const monthAbbr = date.toLocaleString('en-US', { month: 'short' });

  // 获取日期和年份
  const day = date.getDate();
  const year = date.getFullYear();

  // 拼接成所需格式
  const formattedDate = `${monthAbbr}. ${day}, ${year}`;
  return formattedDate;
}

export function getImageBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export const languageOptions = [
  {
    id: 'en',
    name: '英语',
  },
  {
    id: 'zh',
    name: '中文',
  },
  {
    id: 'fr',
    name: '法语',
  },
  {
    id: 'es',
    name: '西班牙语',
  },
  {
    id: 'de',
    name: '德语',
  },
  {
    id: 'ja',
    name: '日语',
  },
  {
    id: 'ko',
    name: '韩语',
  },
  {
    id: 'ar',
    name: '阿拉伯语',
  },
  {
    id: 'ru',
    name: '俄语',
  },
];
export const templateOptions = [
  {
    id: 'b5b65402-1d20-4ea4-afd3-109985edc0b5',
    name: 'Blog',
    style: 'blog-template.min.css?v=1.0.2',
    script: 'article.min.js?v=1.0.2',
  },
  {
    id: 'f938432f-d58d-494f-b468-bcd80d77359d',
    name: 'Help',
    style: 'help-template.min.css?v=1.0.2',
    script: 'help.min.js?v=1.0.2',
  },
];

export const createBlogHtml = (record, userInfo) => {
  const crumbs = record.crumbs.split(',');
  const pageLevel1 = crumbs[0];
  const pageLevel2 = crumbs[1];
  const template = templateOptions.find((item) => item.name === 'Blog');
  // HTML 文件内容
  const htmlContent = `
          <!DOCTYPE html>
          <html lang="${record.languageId}">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="index, follow" />
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-FMLDDXRF14"></script>
            <script>
              window.dataLayer = window.dataLayer || [];
              function gtag() {
                dataLayer.push(arguments);
              }
              gtag('js', new Date());

              gtag('config', 'G-FMLDDXRF14');
            </script>

            <meta name="theme-color" content="#0E0E0E" />
            <meta property="og:site_name" content="Poindeo" />
            <meta property="og:locale" content="en_US" />
            <meta http-equiv="X-UA-Compatible" content="ie=edge" />
            <meta name="msapplication-TileColor" content="#0E0E0E" />
            <meta name="template-color" content="#0E0E0E" />
            <link rel="canonical" href="https://poindeo.com/${pageLevel2.toLowerCase()}/${record.fileName}" />
            <meta
              name="description"
              content="${record.description}"
            />
            ${
              record.keywords &&
              `<meta
                name="keywords"
                content="${record.keywords}"
              />`
            }
              <!--favicon-->
              <link rel="shortcut icon" href="https://poindeo.com/favicon.ico" type="image/x-icon" />
              <link rel="icon" href="https://poindeo.com/favicon.ico" type="image/x-icon" />
              <link rel="icon" type="image/png" sizes="32x32" href="https://poindeo.com/favicon-32x32.png" />
              <link rel="icon" type="image/png" sizes="16x16" href="https://poindeo.com/favicon-16x16.png" />

              <!-- Open Graph / Facebook -->
              <meta property="og:type" content="article" />
              <meta property="og:url" content="https://poindeo.com/${pageLevel2.toLowerCase()}/${record.fileName}" />
              <meta property="og:title" content="${record.title}" />
              <meta property="og:description"
                content="${record.description}" />

              <!-- Open Graph images -->
              <meta property="og:image" content="https://source.poindeo.com/imgs/poindeo-1200x630.png" />
              <meta property="og:image:width" content="1200" />
              <meta property="og:image:height" content="630" />
              <meta property="og:image:type" content="image/png" />
              <meta property="og:image:alt"
                content="${record.title}" />

              <meta property="og:image" content="https://source.poindeo.com/imgs/poindeo-630x315.png" />
              <meta property="og:image:width" content="630" />
              <meta property="og:image:height" content="315" />
              <meta property="og:image:type" content="image/png" />
              <meta property="og:image:alt"
                content="${record.title}" />

              <meta name="twitter:image" content="https://source.poindeo.com/imgs/poindeo-1200x630.png" />
              <link rel="apple-touch-icon" sizes="180x180" href="https://poindeo.com/apple-touch-icon.png" />

              <!-- Twitter -->
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:url" content="https://poindeo.com/${pageLevel2.toLowerCase()}/${record.fileName}" />
              <meta name="twitter:title" content="${record.title}" />
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
              <link
                href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap"
                rel="stylesheet"
              />
              <link rel="stylesheet" href="https://poindeo.com/static/fonts/iconfont/iconfont.css" />
              <link href="https://poindeo.com/static/css/style.min.css?v=1.0.1" rel="stylesheet" />
              <link href="https://poindeo.com/static/css/${template.style}" rel="stylesheet" />
              <title>${record.title}</title>

              <!--author-->
              <meta name="author" content="${userInfo.userName}" />
              <meta property="article:published_time" content="${moment().utc().format('YYYY-MM-DDTHH:mm:ss+00:00')}" />
              <meta property="article:modified_time" content="${moment().utc().format('YYYY-MM-DDTHH:mm:ss+00:00')}" />
              <meta property="article:author" content="${
                userInfo.userId === 'c9d251cd-035a-47a1-85cf-f91749c7a16f'
                  ? 'https://x.com/virgil_dean94'
                  : 'https://x.com/poindeo'
              }" />

              <!--umami-->
              <script
                defer
                src="https://umami.virgil1126.workers.dev/"
                data-website-id="4ce5096b-220d-4b78-a879-02d0a37af724"
              ></script>
              <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
              <script type="application/ld+json">
                {
                  "@context": "https://schema.org",
                  "@type": "Article",
                  "headline": "${record.title}",
                  "description": "${record.description}",
                  "image": "https://source.poindeo.com/imgs/poindeo-1200x630.png",
                  "author": {
                    "@type": "Person",
                    "name": "${userInfo.userName}",
                    "sameAs": [
                      ${
                        userInfo.userId === 'c9d251cd-035a-47a1-85cf-f91749c7a16f'
                          ? '"https://x.com/virgil_dean94"'
                          : '"https://x.com/poindeo"'
                      }
                    ]
                  },      
                  "publisher": {
                    "@type": "Organization",
                    "name": "Poindeo",
                    "logo": {
                      "@type": "ImageObject",
                      "url": "https://poindeo.com/favicon-32x32.png"
                    }
                  },
                  "datePublished": "${moment().utc().format('YYYY-MM-DDTHH:mm:ss+00:00')}",
                  "dateModified": "${moment().utc().format('YYYY-MM-DDTHH:mm:ss+00:00')}"
                }
                </script>
          </head>
          <body>
            <div id="preloader-active">
              <div class="preloader">
                <div class="loader"></div>
              </div>
            </div>
            <div class="article-container">
              <div class="article-box">
                  <div class="floating-menu" id="floating-menu">
                    <div class="share-buttons">
                      Share
                      <a
                        href="https://twitter.com/share?text=${
                          record.title
                        }&url=https://poindeo.com/${pageLevel2.toLowerCase()}/${record.fileName}"
                        target="_blank"
                        rel="nofollow noreferrer noopener"
                        class="share-btn x-btn"
                        title="Share"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                          class="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-rxcuwo r-1777fci r-m327ed r-494qqr"
                        >
                          <g>
                            <path
                              d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                            ></path>
                          </g>
                        </svg>
                      </a>
                      <a
                        href="https://www.facebook.com/sharer/sharer.php?u=https://poindeo.com/${pageLevel2.toLowerCase()}/${
    record.fileName
  }&title=${record.title}&text=${record.description}"
                        target="_blank"
                        rel="nofollow noreferrer noopener"
                        class="share-btn facebook-btn"
                        title="Share"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="#1877F2">
                          <path
                            d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24h11.495v-9.294H9.847v-3.622h2.973V8.413c0-2.946 1.798-4.552 4.423-4.552 1.257 0 2.337.093 2.653.135v3.076h-1.82c-1.428 0-1.703.678-1.703 1.672v2.191h3.406l-.444 3.622h-2.962V24h5.805c.73 0 1.325-.593 1.325-1.324V1.325C24 .593 23.407 0 22.675 0z"
                          />
                        </svg>
                      </a>
                      <a
                        href="https://www.reddit.com/submit?url=https://poindeo.com/${pageLevel2.toLowerCase()}/${
    record.fileName
  }&title=${record.title}"
                        target="_blank"
                        rel="nofollow noreferrer noopener"
                        class="share-btn reddit-btn"
                        title="Share"
                      >
                        <svg
                          t="1741264743848"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2698"
                          width="48"
                          height="48"
                        >
                          <path d="M344 568m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z" p-id="2699"></path>
                          <path
                            d="M626.7 687.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1c14.4-11.4 16.9-32.3 5.5-46.7-11.3-14.4-32.3-16.9-46.7-5.5z"
                            p-id="2700"
                          ></path>
                          <path
                            d="M960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123c-16-4.6-32.8 3.2-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2-19.1-34.3-55.8-57.5-97.9-57.5-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5c17.4 0 31.5 14.1 31.5 31.5s-14.1 31.5-31.5 31.5-31.5-14.1-31.5-31.5 14.1-31.5 31.5-31.5zM120 456c0-30.9 25.1-56 56-56 22.3 0 41.6 13.1 50.6 32.1-29.3 22.2-53.5 47.8-71.5 75.9-20.5-8.3-35.1-28.5-35.1-52z m392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 0.1 23.5-14.5 43.7-35.1 52z"
                            p-id="2701"
                          ></path>
                          <path d="M680 568m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z" p-id="2702"></path>
                        </svg>
                      </a>
                    </div>
                  </div>
                  <div class="article-content">
                    <div class="article-crumbs">
                      <a href="https://poindeo.com" rel="noopener">${pageLevel1}</a> > 
                      <a href="https://poindeo.com/${pageLevel2.toLowerCase()}/" rel="noopener">${pageLevel2}</a> > 
                      <span>${record.subject}</span>
                    </div>
                    <div class="editor-content">${record.content}</div>
                  </div>
               </div>
            </div>
            <script src="https://poindeo.com/static/js/main.min.js?v=1.0.1"></script>
            <script src="https://poindeo.com/static/js/${template.script}"></script>
          </body>
          </html>
        `;
  // 直接替换所有的 myscript 为 script
  // return htmlContent.replaceAll('myscript', 'script');
  return htmlContent;
};

export const createHelpHtml = (record) => {
  const crumbs = record.crumbs.split(',');
  // const pageLevel1 = crumbs[0];
  const pageLevel2 = crumbs[1];
  const template = templateOptions.find((item) => item.name === 'Help');
  // HTML 文件内容
  const htmlContent = `
          <!DOCTYPE html>
          <html lang="${record.languageId}">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="index, follow" />
            
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-FMLDDXRF14"></script>
            <script>
              window.dataLayer = window.dataLayer || [];
              function gtag() {
                dataLayer.push(arguments);
              }
              gtag('js', new Date());

              gtag('config', 'G-FMLDDXRF14');
            </script>

            <meta name="theme-color" content="#0E0E0E" />
            <meta property="og:site_name" content="Poindeo" />
            <meta property="og:locale" content="en_US" />
            <meta http-equiv="X-UA-Compatible" content="ie=edge" />
            <meta name="msapplication-TileColor" content="#0E0E0E" />
            <meta name="template-color" content="#0E0E0E" />
            <link rel="canonical" href="https://poindeo.com/${pageLevel2.toLowerCase()}/${record.fileName}" />
            <meta
              name="description"
              content="${record.description}"
            />
            ${
              record.keywords &&
              `<meta
                name="keywords"
                content="${record.keywords}"
              />`
            }
              <!--favicon-->
              <link rel="shortcut icon" href="https://poindeo.com/favicon.ico" type="image/x-icon" />
              <link rel="icon" href="https://poindeo.com/favicon.ico" type="image/x-icon" />
              <link rel="icon" type="image/png" sizes="32x32" href="https://poindeo.com/favicon-32x32.png" />
              <link rel="icon" type="image/png" sizes="16x16" href="https://poindeo.com/favicon-16x16.png" />

              <!-- Open Graph / Facebook -->
              <meta property="og:type" content="website" />
              <meta property="og:url" content="https://poindeo.com/${pageLevel2.toLowerCase()}/${record.fileName}" />
              <meta property="og:title" content="${record.title}" />
              <meta
                property="og:description"
                content="${record.description}"
              />

              <!-- Open Graph images -->
              <meta property="og:image" content="https://source.poindeo.com/imgs/poindeo-1200x630.png" />
              <meta property="og:image:width" content="1200" />
              <meta property="og:image:height" content="630" />
              <meta property="og:image:type" content="image/png" />
              <meta property="og:image:alt" content="${record.title}" />

              <meta property="og:image" content="https://source.poindeo.com/imgs/poindeo-630x315.png" />
              <meta property="og:image:width" content="630" />
              <meta property="og:image:height" content="315" />
              <meta property="og:image:type" content="image/png" />
              <meta property="og:image:alt" content="${record.title}" />

              <meta name="twitter:image" content="https://source.poindeo.com/imgs/poindeo-1200x630.png" />
              <link rel="apple-touch-icon" sizes="180x180" href="https://poindeo.com/apple-touch-icon.png" />

              <!-- Twitter -->
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:url" content="https://poindeo.com/${pageLevel2.toLowerCase()}/${record.fileName}" />
              <meta name="twitter:title" content="${record.title}" />
              <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link
              href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap"
              rel="stylesheet"
            />
            <link rel="stylesheet" href="https://poindeo.com/static/fonts/iconfont/iconfont.css?v=1.0.9" />
            <link href="https://poindeo.com/static/css/style.min.css?v=1.0.1" rel="stylesheet" />
            <link href="https://poindeo.com/static/css/${template.style}" rel="stylesheet" />
            <title>${record.title}</title>
            <!--umami-->
            <script
            defer
            src="https://umami.virgil1126.workers.dev/"
            data-website-id="4ce5096b-220d-4b78-a879-02d0a37af724"
          ></script>
          </head>
          <body>
            <div id="preloader-active">
              <div class="preloader">
                <div class="loader"></div>
              </div>
            </div>
            <div class="help-container">
              <div class="help-box">
                  <div class="floating-menu" id="floating-menu">
                    <iframe src="https://poindeo.com/layout/help-right-menu.html" style="height: 100%; width: 100%" frameborder="0"></iframe>
                  </div>
                  <div class="help-content">
                    <div class="editor-content">${record.content}</div>
                    <div class="submit-req">
                      <span>Need more help?</span>
                      <a href="mailto:contact@poindeo.com" rel="noopener"> Contact support </a>
                    </div>
                  </div>
                  
               </div>
            </div>
            <script src="https://poindeo.com/static/js/main.min.js?v=1.0.1"></script>
            <script src="https://poindeo.com/static/js/${template.script}"></script>
          </body>
          </html>
        `;
  // 直接替换所有的 myscript 为 script
  // return htmlContent.replaceAll('myscript', 'script');
  return htmlContent;
};
